// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drawer-button[data-v-536c4c54] {\n  padding: 20px 20px;\n  text-align: right;\n  position: absolute;\n  bottom: 0;\n  background-color: #fff;\n  width: 100%;\n  border-top: 1px solid #EBEEF5;\n}\n", ""]);
// Exports
module.exports = exports;
